<template>
  <div class="container">
    <SearchForm :value="text" @change="handleSearch" />
    <SearchResults v-if="results" :results="results" :term="text" />
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import matomoPageTracker from 'beisheim/mixins/matomo-page-tracker'
import SearchForm from 'beisheim/components/elements/search-form'
import SearchResults from 'beisheim/components/elements/search-results'

export default {
  components: {
    SearchForm,
    SearchResults
  },
  mixins: [ editable, matomoPageTracker ],
  data () {
    return {
      text: null,
      results: null
    }
  },
  async mounted () {
    if (this.$route.query.text) {
      this.text = this.$route.query.text
      await this.handleSearch(this.text)
    }
  },
  methods: {
    async handleSearch (search) {
      this.text = search
      this.$router.push({ query: { text: search } })
      const response = await this.$axios.post('/search', {
        resource_id: this.$currentLocale.id,
        query: search
      })
      this.results = response.data
    }
  },
  head () {
    return {
      title: this.$i18n('search')
    }
  }
}
</script>
